//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Display.js";
import "../no/Builder.js";
import "../no/Expression.js";
import "../no/ugmath.js";
import "../no/View.js";
import "../no/Expression.js";
let d=[[[0,"ColorSaturation",1,0],[0,"DisplayStyle",0,0],[0,"EnvironmentShadedViewsFixGroundPlaneOffset",1,0],[0,"EnvironmentShadedViewsGlobalFinish",1,1],[0,"EnvironmentShadedViewsGroundPlane",1,0],[0,"EnvironmentShadedViewsGroundPlaneCustom",1,"Plane",0],[0,"EnvironmentShadedViewsGroundPlaneOffset",1,0],[0,"EnvironmentShadedViewsGroundRefReflectivity",1,0],[0,"EnvironmentShadedViewsShowGroundReflection",1,0],[0,"GroundGlossiness",1,0],[0,"GroundPlaneType",1,0],[0,"GroundReflection",1,0],[0,"GroundVisibility",1,0],[0,"Hdr",1,0],[0,"Image",1,"Display.Image",0],[0,"ImageBlur",1,0],[0,"ImageFilename",1,0],[0,"ImageRotation",1,0],[0,"ImageUpVector",1,"Direction",0],[0,"ImageUpVectorCoordinate",1,0],[0,"ImageUpVectorType",1,0],[0,"LightIntensity",1,0],[0,"LwrtAngle",1,0],[0,"LwrtIntensity",1,0],[0,"LwrtQuality",1,0],[1,"OffsetExpression",0,"Expression",0],[0,"Reflectivity",1,0],[1,"SizeExpression",0,"Expression",0],[0,"SpecifyGroundPlane",1,"Plane",0],[0,"UseEnvironment",1,0],[0,"UseLightsForShadowCatcherInLwrt",1,0],[0,"UseLwrtEnvironment",1,0],[0,"ViewFitToStage",1,0]],[[["nGroundReflectionColor"],"GetGroundReflectionColor",{R_:{groundReflectionColor:""}},0,0],[["groundReflectionColor"],"SetGroundReflectionColor",{},1,0],[["view","update_ibl_display","update_env_cube_display"],"CommitAndDisplay",{},3,0],[["view"],"CommitOffset",{},1,0],[[],"FloorXaxis",{},0,0],[[],"FloorYaxis",{},0,0],[[],"FloorZaxis",{},0,0],[["specifyFloorPlane"],"AlignFloorPlane",{},1,0]],[]];
SPLM.Display.EnvironmentBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Display.EnvironmentBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Display.EnvironmentBuilder.ImageBlurType = Object.freeze({
    "None" : "None", "Low" : "Low", "Medium" : "Medium", "High" : "High"});

SPLM.Display.EnvironmentBuilder.ImageUpVectorTypes = Object.freeze({
    "AlignWithFloorPlane" : "AlignWithFloorPlane", "UserDefined" : "UserDefined"});

SPLM.Display.EnvironmentBuilder.ToneMappingTypes = Object.freeze({
    "SystemScene" : "SystemScene", "UserDefined" : "UserDefined"});

SPLM.Display.EnvironmentBuilder.GroundPlaneTypes = Object.freeze({
    "Yz" : "Yz", "Xz" : "Xz", "Xy" : "Xy", "UserDefined" : "UserDefined"});

SPLM.Display.EnvironmentBuilder.HdrTypes = Object.freeze({
    "None" : "None", "Lighting1" : "Lighting1", "Lighting2" : "Lighting2", "Lighting3" : "Lighting3"});

SPLM.Display.EnvironmentBuilder.GlobalFinishType = Object.freeze({
    "ShinyPlastic" : "ShinyPlastic", "ClassicSatin" : "ClassicSatin", "MattePlastic" : "MattePlastic", "Flat" : "Flat", "UserDefined" : "UserDefined"});

export default SPLM;